<template>
  <div
    class="tm-avatar-wrapper"
    :class="{
      'tm-avatar-wrapper--outlined': outlined,
      'tm-avatar-wrapper--bordered': bordered,
      [`bg-color--${backgroundColor}`]: true,
    }"
  >
    <div class="tm-avatar-wrapper__content">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from '@/composition/vue/compositionApi'
import type { PropType } from '@/composition/vue/compositionApi'
import { addPxToNumber } from '@/utils/string/addPxToNumber'
import { type StyleColors, styleColorsMainVariant } from '@/constants/styleColors'

export default defineComponent({
  props: {
    outlined: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 28,
    },
    color: {
      type: String as PropType<StyleColors>,
      default: 'gray',
    },
    bordered: {
      type: Boolean,
    },
    exactColor: Boolean,
  },
  setup(props) {
    const sizePx = computed(() => addPxToNumber(props.size))

    const backgroundColor = computed<StyleColors>(() => {
      const mainColors = [...styleColorsMainVariant] as string[]
      if (!props.exactColor && mainColors.includes(props.color)) {
        return `${props.color}100` as StyleColors
      }
      return props.color
    })

    return {
      sizePx,
      backgroundColor,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.tm-avatar-wrapper {
  position: relative;
  overflow: visible;
  flex-shrink: 0;

  vertical-align: middle;
  display: inline-block;
  border-radius: 50%;
  font-size: v-bind(sizePx);
  height: 1em;
  width: 1em;

  &__content {
    width: 100%;
    height: 100%;
    min-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: var(--tm-avatar-bg);
  }

  &--outlined {
    background: $white;
    border: 1px solid $border-color;
  }

  &--bordered {
    @include bordered-avatar();
  }
}
</style>
